import usePageTitle from '../../hooks/usePageTitle';

/**
 * The browser tab / history title of a page: "O'quvchilar · Darsly CRM". The title of the screen
 * that was open before comes back when this one goes away. A page passes its own translated title;
 * on a nested route it also becomes the last top-bar breadcrumb (see hooks/usePageTitle).
 */
export default function useDocumentTitle(title) {
  usePageTitle(title);
}
